<template>
    <div class="question-item">
        <div v-show="(showQuestion && showQuestion.id === question.id) || show" class="question-title">
            <span>{{ question.indexNo }}. </span>
            <template v-for="(item, index) in titleList">
                <TextTemplate class="title-item" v-if="item.type === 'text'" :key="index" :text="item.title" />
                <div v-else-if="item.type === 'answer'" :key="`index-${index}`" class="answer">
                    {{ item.value }}
                </div>
            </template>
        </div>
        <Result :question="question" />
    </div>
</template>
<script>
import TextTemplate from '../../TextTemplate.vue'
import Result from '../Result.vue'

export default {
    components: { TextTemplate, Result },
    computed: {
        questionAnalysisMap() {
            return this.$store.state.paperResult.questionAnalysisMap
        },
        showQuestion() {
            const state = this.$store.state.paperResult
            if (state.currentSubQuestion) return state.currentSubQuestion
            if (state.currentQuestion) return state.currentQuestion
            return null
        },
    },
    props: ['question', 'show'],
    data() {
        return {
            titleList: [],
        }
    },
    created() {
        const analysis = this.questionAnalysisMap[`q-${this.question.id}`]
        const successList = analysis ? analysis.answer.split('||').join('或').split('@@') : []

        // 处理 content
        const list = []
        // TODO 填空题格式兼容
        if (this.question.content.indexOf('_____') > -1) {
            this.question.content.split('_____').forEach((str, i) => {
                list.push({ type: 'text', title: str })
                list.push({ type: 'answer', value: successList[i] })
            })
        } else {
            this.question.content.split(/BLANK__\d+/).forEach((str, i) => {
                list.push({ type: 'text', title: str })
                list.push({ type: 'answer', value: successList[i] })
            })
        }
        list.pop()
        this.titleList = list
    },
}
</script>
<style lang="scss" scoped>
@import '@/scss/paper.scss';

.question-title {
    line-height: 36px;
    .title-item {
        display: inline;
    }
    .answer {
        display: inline-block;
        padding: 0 12px;
        color: $success-color;
        border-bottom: 1px solid $success-color;
        margin: 0 8px;
        height: 28px;
    }
}
</style>
